import React, { useEffect, useState } from "react";
import closeBtn from "../../assets/svg/free-icon-minimize-sign-6057365 2.svg";
import copyIcon from "../../assets/svg/icon.svg";

const ChangePasswordForm = ({ changeIsOurCompanyOpen }) => {
  const [family, setFamily] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurame] = useState("");
  const [dative, setDative] = useState("");
  const [genitive, setGenitive] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [city, setCity] = useState("");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleSubmit = (e) => {};

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 
  return (
    <div className="overlay">
        {windowWidth <= 920 && (
          <div className="closeForm2">
          <button
            className="closePasswordFormBtn"
            onClick={changeIsOurCompanyOpen}
          >
            <img src={closeBtn} alt="CloseBtn" />
          </button>
        </div>
        )}
      <div className="form-container ourCompany">
        {/* Editable from here */}
        <h2 className="header">Наша компания</h2>
        <form onSubmit={handleSubmit}>
          <div className="upperNav-left">
            <button className="upperNav-btn">Наша компания</button>
            <a className="upperNav-btn" href="/" data-discover="true">
              Карточка
            </a>
            <a className="upperNav-btn" href="/" data-discover="true">
              Закладки
            </a>
            <button className="upperNav-btn">Поиск</button>
          </div>
          {/* Table  */}
          <table className="table">
            <thead className="table-header">
              <tr className="table-row">
                <td className="table__header-cell">№</td>
                <td className="table__header-cell">Наименование</td>
                <td className="table__header-cell">Менеджер</td>
                <td className="table__header-cell">Адрес</td>
                <td className="table__header-cell">Дата занесения</td>
                <td className="table__header-cell"></td>
              </tr>
            </thead>
            <tbody className="table__body">
              <tr className="table-row">
                <td className="table-cell">1</td>
                <td className="table-cell">Наша компания</td>
                <td className="table-cell">Попов А.Я.</td>
                <td className="table-cell">
                  125599, г.Москва, Дмитровский р-н, МКАД 78-й км, д 14, к 1
                </td>
                <td className="table-cell table-cell__flex">
                  29/09/2024 <span>18:20:42</span>
                </td>
                <td className="table-cell__img">
                  <img src={copyIcon} alt="Icon" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell">1</td>
                <td className="table-cell">Наша компания</td>
                <td className="table-cell">Попов А.Я.</td>
                <td className="table-cell">
                  109202, г. Москва, улица Ленина, д.6 офис 320
                </td>
                <td className="table-cell table-cell__flex">
                  29/09/2024 <span>18:20:42</span>
                </td>
                <td className="table-cell__img">
                  <img src={copyIcon} alt="Icon" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell">1</td>
                <td className="table-cell">Наша компания</td>
                <td className="table-cell">Попов А.Я.</td>
                <td className="table-cell">
                  109202, г. Москва, улица Ленина, д.6 офис 320
                </td>
                <td className="table-cell table-cell__flex">
                  29/09/2024 <span>18:20:42</span>
                </td>
                <td className="table-cell__img">
                  <img src={copyIcon} alt="Icon" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell">1</td>
                <td className="table-cell">Наша компания</td>
                <td className="table-cell">Попов А.Я.</td>
                <td className="table-cell">
                  109202, г. Москва, улица Ленина, д.6 офис 320
                </td>
                <td className="table-cell table-cell__flex">
                  29/09/2024 <span>18:20:42</span>
                </td>
                <td className="table-cell__img">
                  <img src={copyIcon} alt="Icon" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell">1</td>
                <td className="table-cell">Наша компания</td>
                <td className="table-cell">Попов А.Я.</td>
                <td className="table-cell">
                  109202, г. Москва, улица Ленина, д.6 офис 320
                </td>
                <td className="table-cell table-cell__flex">
                  29/09/2024 <span>18:20:42</span>
                </td>
                <td className="table-cell__img">
                  <img src={copyIcon} alt="Icon" />
                </td>
              </tr>
              <tr className="table-row">
                <td className="table-cell">1</td>
                <td className="table-cell">Наша компания</td>
                <td className="table-cell">Попов А.Я.</td>
                <td className="table-cell">
                  109202, г. Москва, улица Ленина, д.6 офис 320
                </td>
                <td className="table-cell table-cell__flex">
                  29/09/2024 <span>18:20:42</span>
                </td>
                <td className="table-cell__img">
                  <img src={copyIcon} alt="Icon" />
                </td>
              </tr>
            </tbody>
          </table>

          {/* Editable till here */}
          <button type="submit" className="btn popPasswordBtn">
            Сохранить
          </button>
          <button type="submit" className="btn popPasswordBtn">
            Добавить юридическое лицо
          </button>
        </form>

        <div className="closeForm">
          <button
            className="closePasswordFormBtn"
            onClick={changeIsOurCompanyOpen}
          >
            <img src={closeBtn} alt="CloseBtn" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
